import { render, staticRenderFns } from "./fgt-icons.vue?vue&type=template&id=5d00f1f2&"
import script from "./fgt-icons.vue?vue&type=script&lang=js&"
export * from "./fgt-icons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports